import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';

type Props = {
  onAdd: (contentPackId: string) => void;
};

export default function PlaylistAdd({ onAdd }: Props) {
  const [open, setOpen] = useState(false);
  const [contentPackId, setContentPackId] = useState('');

  const submit = () => {
    const trimmed = contentPackId.trim();
    if (!trimmed) return;
    onAdd(trimmed);
    setContentPackId('');
    setOpen(false);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      submit();
    }
  };

  if (!open) {
    return (
      <Button variant="primary" size="sm" onClick={() => setOpen(true)}>
        Add saved content pack
      </Button>
    );
  }

  return (
    <InputGroup size="sm" style={{ width: 340 }}>
      <Form.Control
        autoFocus
        placeholder="Saved content pack ID"
        value={contentPackId}
        onChange={(e) => setContentPackId(e.target.value)}
        onKeyPress={handleKeyPress}
      />
      <Button variant="primary" onClick={submit} disabled={!contentPackId.trim()}>
        Add
      </Button>
      <Button
        variant="outline-secondary"
        onClick={() => {
          setContentPackId('');
          setOpen(false);
        }}
      >
        Cancel
      </Button>
    </InputGroup>
  );
}
